HuesMdl.controller( 'HuesCtrl', ['$scope', '$state', 'CATALOG_URL', 'HuesUpdaterSrv', 'HuesSrv', 'category', 'effect_fan',
	function ( $scope, $state, CATALOG_URL, HuesUpdaterSrv, HuesSrv, category, effect_fan ) {

	var self = this;

	this.loading = true;
	this.busy = false;
	this.hues = [];
	this.not_found = false;
	this.neutral_fan_id = false;
	this.single = $state.params.hue_code ? $state.params.hue_code.replace('_', ' ') : false;
	this.CATALOG_URL = CATALOG_URL.URL;
	this.isSearch = false;





	/**
	 * Watcher for a service value changes.
	 * This value is being updating by other controllers on runtime according to the user actions on the page
	 * after the states has being loaded.
	 */
	$scope.$watch(function () { return HuesUpdaterSrv.getHues;}, function( getHues ){

		if( getHues )
			self.getHues();
		else
			self.hues = [];

		HuesUpdaterSrv.getHues = false;
	});


	$scope.$watch(function () { return HuesUpdaterSrv.isSearch;}, function( isSearch ){
		self.isSearch = isSearch;
		if( isSearch) {
			self.texture = false;
			self.neutral_fan_id = false;
		}
	});





	this.getHues = function() {

		this.loading = true;
		this.not_found = false;
		HuesSrv.getHues().then(
				function( hues ) {
					singleHueWatch();
					if( singleStateHandler( hues ) ) {
						self.hues = hues;
						HuesUpdaterSrv.hasHues = true;
						self.loading = false;
					}
				}, function() {
					self.not_found = true;
					self.loading = false;
				}
		);
	};




	if( effect_fan && ( effect_fan.fan_type === "neutral-effect-fan" || effect_fan.fan_type === "neutral-schlicht-fan" ) ) {
		this.texture = effect_fan.texture;
		this.neutral_fan_id = effect_fan.id;
		this.neutral_fan_slug = effect_fan.slug;
	}



	/**
	 * Load more hues when the user scrolls to document bottom.
	 */
	this.loadMorehues = function() {
		if ( this.busy || this.loading ) return;


		this.busy = true;

		HuesSrv.getResults().then(
				function( hues ) {
					self.hues = self.hues.concat( hues );
					self.busy = false;
				},
				function() {
					self.busy = false;
				}
		);

	};



	if ( category.filter_through !== 'categories-select' )
		this.getHues();






	function singleHueWatch(){
		$scope.$watch(function () { return $state.params.hue_code; }, function ( single, oldSingle ) {

			if( typeof single === 'undefined' ) {
				self.single = false;
				return;
			}


			self.single = single.replace('_', ' ');
		});
	}



	function singleStateHandler( hues ){
		if( self.isSearch )
			return true;

		/**
		 * We are not in single state,
		 * Or we are in a category filtered by select boxes ( not shown in state params ) can proceed.
		 */

		if( ! self.single || ( category.filter_through === 'categories-select' ))
			return true;



		var huesCodes = hues.map(function(hue){return hue.hue_code});





		//The single hue that was passed as a parameter is in the hue list, can proceed and handle it.
		if ( huesCodes.indexOf( self.single ) !== -1 )
			return true;


		HuesSrv.setFilter('hue', self.single.replace(' ', '_'));
		$state.reload();

	}
}]);